import { api } from './api';


const getBankImageList = async ({pageNumber = 1, pageSize = 10}) => {
    const response = await api({
        url: `Banks/getListWithImage`,
        method: 'GET',
        params: {
            Page: pageNumber,
            PageSize: pageSize
        },
    });
    return response.data;
};
const getBankImagesList = () => {
  return getBankImageList({pageNumber: 0, pageSize: 0})
};

const updateBank = async (data) => {
    const response = await api({
        url: `Banks`,
        method: 'PUT',
        data,
    });
    return response.data;
};

const deleteBank = async (data) => {
    const response = await api({
        url: `Banks?id=${data.id}`,
        method: 'DELETE',
        data,
    });
    return response.data;
};

const addNewBank = async (data) => {
    const response = await api({
        url: `Banks`,
        method: 'POST',
        data,
    });
    return response.data;
};

const getDirectWireTransferBankImages = async () => {
    const response = await api({
        url: `Banks/getList`,
        method: 'GET',
    });
    return response.data;
};

const bankServices = {
  getBankImagesList,
  getDirectWireTransferBankImages,
  getBankImageList,
  updateBank,
  deleteBank,
  addNewBank,
};

export default bankServices;
